<template>
  <div class="container page video-detail-page">
    <van-nav-bar :title="this.videoInfo.vod_name" class="nav-bar">
      <template #left>
        <button class="nav-back" type="button" aria-label="Back" @click="back()">
          <van-icon name="arrow-left" />
        </button>
      </template>
    </van-nav-bar>
    <div class="movie-video" aria-label="Video player">
      <video id="my-video" class="video-js" playsinline>
      </video>
    </div>
    <main class="movie-content">
      <div class="movie-descript">
        <div>
          <div class="content-eyebrow">Victoria private cinema</div>
          <h1>{{ this.videoInfo.vod_name}}</h1>
        </div>
        <span class="view-count"><van-icon name="eye-o" /> {{this.videoInfo.count}} View</span>
      </div>

      <section class="movie-body" aria-label="More videos">
        <div class="movie-title">
          <div>
            <h2>See more</h2>
          </div>
        </div>
        <div class="movie-list">
          <button class="movie-play-item" type="button" @click="toPlayVideo(v.id)" v-for="(v,key) in moreVideoInfo" :key="key">
            <div>
              <img :src="v.vod_pic" :alt="v.vod_name" loading="lazy">
              <div>
                <div class="van-count-down">{{ v.time }}</div>
              </div>
            </div>
            <div>
              <p>{{ v.vod_name }}</p>
              <span><van-icon name="eye-o" /> {{ v.count }} View</span>
            </div>
          </button>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover:"",
      userInfo:[],
      videoInfo:{},
      moreVideoInfo:{},
      player:null,
      is_play:false,
      times: null,
      is_see:0,
      see_num:15,
      see_times:0,
      watch_times:0,
      retryCount: 0,
      maxRetry: 999, // 几乎无限重试
      isRetrying: false,
      loadTimeout: null,
    };
  },
  methods: {
    back(){
      this.$router.push({path:'Home'})
    },
    getVideoInfo(){

      this.$http({
        method: 'get',
        data:{id:this.$route.query.id},
        url: 'video_get_info'
      }).then(res=>{
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.cover = this.videoInfo.vod_pic;
        let videos = document.getElementById('my-video');
        videos.poster = this.cover;
        this.getVideo();
      })

    },
    toPlayVideo(id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'?id='+id})
        location.reload();
      }

    },
    getMoreVideoItem(){
      this.$http({
        method: 'get',
        url: 'video_get_more_item'
      }).then(res=>{
          this.moreVideoInfo = res.data;
      })
    },
    getVideo() {
      if (this.isRetrying) {
        return;
      }
      
      // 清除之前的超时定时器
      if (this.loadTimeout) {
        clearTimeout(this.loadTimeout);
        this.loadTimeout = null;
      }
      
      try {
        // 清除之前的错误监听
        this.player.off('error');
        this.player.off('loadeddata');
        this.player.off('loadstart');
        this.player.off('waiting');
        this.player.off('canplay');
        
        // 多格式支持
        const videoUrl = this.nowPlayVideoUrl;
        const sources = [];
        
        // HLS格式
        if (videoUrl.includes('.m3u8') || videoUrl.includes('m3u8')) {
          sources.push({
            src: videoUrl,
            type: 'application/x-mpegURL'
          });
          sources.push({
            src: videoUrl,
            type: 'application/vnd.apple.mpegurl'
          });
        } else if (videoUrl.includes('.mp4')) {
          // MP4格式
          sources.push({
            src: videoUrl,
            type: 'video/mp4'
          });
        } else {
          // 默认尝试HLS
          sources.push({
            src: videoUrl,
            type: 'application/x-mpegURL'
          });
        }
        
        // 添加时间戳避免缓存
        const timestamp = new Date().getTime();
        sources.forEach(source => {
          if (source.src.indexOf('?') > -1) {
            source.src += '&t=' + timestamp;
          } else {
            source.src += '?t=' + timestamp;
          }
        });
        
        this.player.src(sources);
        
        // 尝试加载
        this.player.load();
        
        // 监听开始加载
        this.player.one('loadstart', () => {
          console.log('视频开始加载...');
        });
        
        // 监听缓冲中
        this.player.on('waiting', () => {
          console.log('视频缓冲中...');
        });
        
        // 监听可以播放
        this.player.on('canplay', () => {
          console.log('视频可以播放');
        });
        
        // 监听加载完成
        this.player.one('loadeddata', () => {
          this.retryCount = 0;
          this.isRetrying = false;
          if (this.loadTimeout) {
            clearTimeout(this.loadTimeout);
            this.loadTimeout = null;
          }
          console.log('视频加载成功');
        });
        
        // 监听错误并自动重试（静默重试，不显示错误）
        this.player.one('error', () => {
          const error = this.player.error();
          if (error) {
            console.log('视频错误详情:', {
              code: error.code,
              message: error.message,
              url: this.nowPlayVideoUrl,
              retryCount: this.retryCount
            });
          }
          this.handleVideoError();
        });
        
        // 设置超长时间等待（60秒），如果超时则重试
        this.loadTimeout = setTimeout(() => {
          console.log('视频加载超时，准备重试...');
          this.handleVideoError();
        }, 60000);
        
      } catch (e) {
        console.error('getVideo执行出错:', e);
        this.handleVideoError();
      }
    },
    handleVideoError() {
      if (this.isRetrying) {
        return;
      }
      
      const error = this.player.error();
      const errorCode = error ? error.code : 0;
      
      // 几乎无限重试，不显示错误提示
      this.isRetrying = true;
      this.retryCount++;
      
      // 根据重试次数递增延迟，但最多不超过30秒
      let retryDelay;
      if (this.retryCount <= 3) {
        retryDelay = 2000; // 前3次快速重试
      } else if (this.retryCount <= 10) {
        retryDelay = 5000; // 4-10次中速重试
      } else {
        retryDelay = 10000; // 10次以后慢速重试
      }
      
      console.log(`视频加载失败(错误码:${errorCode})，${retryDelay/1000}秒后进行第${this.retryCount}次重试...`);
      
      // 每5次重试完全重建播放器
      if (this.retryCount % 5 === 0 && this.player) {
        try {
          console.log('第' + this.retryCount + '次重试，重建播放器...');
          const oldPlayer = this.player;
          oldPlayer.dispose();
          
          setTimeout(() => {
            this.playVideo();
            setTimeout(() => {
              this.isRetrying = false;
              this.getVideo();
            }, 1000);
          }, retryDelay);
          return;
        } catch (e) {
          console.log('重建播放器时出错:', e);
        }
      }
      
      // 普通重试：重置播放器状态
      if (this.player) {
        try {
          this.player.pause();
          this.player.reset();
        } catch (e) {
          console.log('重置播放器时出错:', e);
        }
      }
      
      setTimeout(() => {
        this.isRetrying = false;
        this.getVideo();
      }, retryDelay);
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          console.log(res.data)
          this.userInfo = res.data;
          this.is_see = this.userInfo.is_see;
          this.see_num = this.userInfo.see_num;
          this.watch_times = this.userInfo.watch_times;
          this.see_times = this.userInfo.see_times;
          if(this.userInfo.status !== 1){
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }else {
            this.getVideoInfo();
            this.getMoreVideoItem();
            this.playVideo();
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    setWatchTimes(){
      this.$http({
        method: 'get',
        url: 'setWatchTimes'
      }).then(res=>{
        if(res.code ===401){
          this.$toast(this.$t("video.buy"));
        }
      })
    },
    playVideo(){
      const _this = this;
      this.player = videojs("my-video",  {
        height:"200px",
        preload: "auto", // 预加载
        controls: true,  // 显示播放的控件
        multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
        html5: {
          hls: {
            overrideNative: true,
            enableLowInitialPlaylist: true,
            smoothQualityChange: true,
            bandwidth: 4194304,
            withCredentials: false,
            // HLS配置优化
            handleManifestRedirects: true,
            useCueTags: false,
          },
          nativeVideoTracks: false,
          nativeAudioTracks: false,
          nativeTextTracks: false,
          // 启用原生HLS支持(对于某些浏览器)
          vhs: {
            overrideNative: true,
          },
        },
        techOrder: ['html5'],
        liveui: false,
        retryOnError: true,
        // 增加错误显示配置
        errorDisplay: false,
      },function(){
        this.on("play",() => {
          _this.is_play=true;
          if(_this.watch_times >= _this.see_times){
            _this.player.pause()
            _this.$toast(_this.$t("video.info"));
            return
          }else{
            _this.setWatchTimes();
          }
        });
        
        // 监听暂停事件，重置重试计数
        this.on('pause', () => {
          if (!_this.isRetrying) {
            _this.retryCount = 0;
          }
        });
      });
    }
  },
  mounted(){
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      // this.playVideo();
      // if(this.watch_times >= this.see_times){
      //   this.player.pause()
      //   this.$toast(this.$t("video.buy"));
      //   return
      // }else{
      //   this.setWatchTimes();
      // }
      // this.times = setInterval(() => {
      //   if(this.is_play && this.is_see == 0){
      //     const ct = Math.round(this.player.currentTime())
      //     if(ct >= this.see_num){
      //       this.player.pause()
      //       this.$toast(this.$t("video.buy"));
      //       return
      //     }
      //   }
      // }, 1000 * 2);
    }

  },
  destroyed () {
    if(this.is_play){
      this.is_play = false;
    }
    if (this.loadTimeout) {
      clearTimeout(this.loadTimeout);
      this.loadTimeout = null;
    }
    clearInterval(this.times);
  }
};
</script>

<style scoped>
@import "../../assets/css/base.css";
.video-js {
  width: 100%;
  /*height: 420px;*/
  font-size: 0.24rem;
}
.movie-content{
  flex: 1;
  overflow-y: auto;
}
.movie-content .movie-descript{
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.15rem;
}
.movie-content .movie-descript p{
  font-size: 0.3rem;
  font-weight: 700;
  color: #000;
}
.movie-content .movie-descript span{
  color: #979799;
  font-size: 0.4rem;
  padding: 0.3rem 0;
}
.movie-content .movie-body{
  width: calc(100% - 0.2rem);
  margin: 0 auto;
}
::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -0.5rem;
  margin-left: -1rem;
}
.movie-content .movie-body .movie-title{
  height: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.movie-content .movie-body .movie-title>div:first-child {
  width: 4.1rem;
}
.movie-content .movie-body .movie-title>div:first-child span{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.3rem;
  font-weight: 700;
  color: #000;
}
.movie-content .movie-body .movie-title>div:first-child span:before {
  content: "";
  display: block;
  width: 0.08rem;
  height: 0.3rem;
  background-color: #5b60df;
  border-radius: 0.25rem;
  margin-right: 0.1rem;
}
.movie-play-item{
  width: 100%;
  height: 2rem;
  border-radius: 0.1rem;
  position: relative;
  display: flex;
  background-color: #fff;
  margin-bottom: 0.2rem;
  box-shadow: 0 0 1.067vw 0 #e4e4e7;
}
.movie-play-item>div{
  height: 100%;
}
.movie-play-item>div:first-child {
  width: 2rem;
  position: relative;
}
.movie-play-item>div:first-child>img{
  width: 100%;
  height: 100%;
  border-radius: 10px 0 0 10px;
}
.movie-play-item>div:first-child>div{
  position: absolute;
  width: 100%;
  height: 0.3rem;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.1rem;
  background-color: rgba(0,0,0,.4);
  border-radius: 0 0 0 0.1rem;
}
.movie-play-item>div:first-child>div .van-count-down {
  color: #fff;
  font-size: 0.25rem;
}
.movie-play-item>div:nth-child(2) p{
  width: 5rem;
  height: 0.6rem;
  font-size: 0.3rem;
  line-height: 0.32rem;
  word-break: break-all;
  overflow: hidden;
  color: #000;
}
.movie-play-item>div:nth-child(2) span{
  color: #979799;
  font-size: 0.4rem;
}
.movie-play-item>div:nth-child(2) {
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
abbr, address, article, aside, audio, b, blockquote, body, canvas, caption, cite, code, dd, del, details, dfn, div, dl, dt, em, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, html, i, iframe, img, ins, kbd, label, legend, li, mark, menu, nav, object, ol, p, pre, q, samp, section, small, span, strong, sub, summary, sup, table, tbody, td, tfoot, th, thead, time, tr, ul, var, video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  box-sizing: border-box;
}

.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.63em !important;
}

/* Victoria Dating Club UI2 */
.video-detail-page {
  padding-bottom: max(0.5rem, env(safe-area-inset-bottom));
  color: var(--victoria-text);
  background: transparent;
}

.video-detail-page .nav-bar {
  flex: 0 0 auto;
  background: rgba(12, 10, 13, 0.88);
  backdrop-filter: blur(14px);
}

.video-detail-page .nav-back {
  display: inline-flex;
  width: 0.88rem;
  height: 0.88rem;
  margin-left: -0.2rem;
  align-items: center;
  justify-content: center;
  color: var(--victoria-text);
  background: transparent;
  border: 0;
  border-radius: 50%;
}

.video-detail-page .nav-back:focus-visible,
.video-detail-page .movie-play-item:focus-visible {
  outline: 2px solid var(--victoria-light-rose);
  outline-offset: 2px;
}

.video-detail-page .movie-video {
  position: relative;
  width: calc(100% - 0.56rem);
  aspect-ratio: 16 / 9;
  flex: 0 0 auto;
  margin: 0.32rem auto 0;
  overflow: hidden;
  background: #050405;
  border: 1px solid var(--victoria-border);
  border-radius: 0.46rem;
  box-shadow: var(--victoria-shadow);
}

.video-detail-page .movie-video::after {
  position: absolute;
  inset: 0;
  z-index: 1;
  content: '';
  pointer-events: none;
  border-radius: inherit;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.03);
}

.video-detail-page .movie-video .video-js {
  width: 100%;
  height: 100% !important;
  font-size: 0.24rem;
  background: #050405;
}

.video-detail-page ::v-deep .video-js .vjs-poster {
  background-size: cover;
}

.video-detail-page ::v-deep .video-js .vjs-control-bar {
  height: 0.86rem;
  color: var(--victoria-light-rose);
  background: linear-gradient(180deg, transparent, rgba(7, 5, 8, 0.94));
}

.video-detail-page ::v-deep .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  width: 1.44rem;
  height: 1.44rem;
  margin: -0.72rem 0 0 -0.72rem;
  line-height: 1.36rem;
  color: #2a171d;
  background: var(--victoria-action);
  border: 1px solid rgba(255, 209, 217, 0.48);
  border-radius: 50%;
  box-shadow: 0 0.18rem 0.58rem rgba(207, 127, 145, 0.36);
}

.video-detail-page ::v-deep .video-js .vjs-play-progress,
.video-detail-page ::v-deep .video-js .vjs-volume-level {
  background: var(--victoria-primary);
}

.video-detail-page .movie-content {
  width: calc(100% - 0.56rem);
  margin: 0.3rem auto 0;
  overflow: visible;
}

.video-detail-page .movie-descript {
  display: flex;
  width: 100%;
  padding: 0.4rem;
  gap: 0.28rem;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
  color: var(--victoria-text);
  background: var(--victoria-surface);
  border: 1px solid var(--victoria-divider);
  border-radius: 0.42rem;
  box-shadow: var(--victoria-shadow);
  backdrop-filter: blur(12px);
}

.video-detail-page .content-eyebrow {
  margin-bottom: 0.08rem;
  color: var(--victoria-text-muted);
  font-size: 0.25rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.video-detail-page .movie-descript h1 {
  margin: 0;
  color: var(--victoria-text);
  font-family: var(--victoria-font-ui);
  font-size: 0.52rem;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.video-detail-page .movie-descript .view-count {
  display: inline-flex;
  flex: 0 0 auto;
  margin: 0;
  padding: 0.13rem 0.2rem;
  gap: 0.1rem;
  align-items: center;
  color: var(--victoria-light-rose);
  font-size: 0.28rem;
  background: rgba(168, 107, 121, 0.18);
  border: 1px solid rgba(231, 160, 174, 0.18);
  border-radius: 999px;
}

.video-detail-page .movie-body {
  width: 100%;
  margin: 0.34rem 0 0;
}

.video-detail-page .movie-title {
  height: auto;
  margin-bottom: 0.22rem;
}

.video-detail-page .movie-title > div:first-child {
  width: 100%;
}

.video-detail-page .movie-title h2 {
  display: flex;
  margin: 0;
  gap: 0.14rem;
  align-items: center;
  color: var(--victoria-text);
  font-family: var(--victoria-font-ui);
  font-size: 0.44rem;
}

.video-detail-page .movie-title h2::before {
  width: 0.08rem;
  height: 0.36rem;
  content: '';
  background: var(--victoria-action);
  border-radius: 999px;
}

.video-detail-page .movie-list {
  display: grid;
  gap: 0.24rem;
}

.video-detail-page .movie-play-item {
  display: grid;
  width: 100%;
  min-height: 2.35rem;
  height: auto;
  grid-template-columns: 2.7rem minmax(0, 1fr);
  padding: 0;
  overflow: hidden;
  color: var(--victoria-text);
  text-align: left;
  background: var(--victoria-surface);
  border: 1px solid var(--victoria-divider);
  border-radius: 0.38rem;
  box-shadow: 0 0.22rem 0.62rem rgba(0, 0, 0, 0.25);
}

.video-detail-page .movie-play-item > div:first-child {
  position: relative;
  width: auto;
  height: 100%;
  min-height: 2.35rem;
  overflow: hidden;
}

.video-detail-page .movie-play-item > div:first-child > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
}

.video-detail-page .movie-play-item > div:first-child > div {
  right: 0.12rem;
  bottom: 0.12rem;
  left: auto;
  width: auto;
  height: auto;
  padding: 0.06rem 0.14rem;
  background: rgba(8, 6, 9, 0.78);
  border: 1px solid var(--victoria-divider);
  border-radius: 999px;
}

.video-detail-page .movie-play-item > div:first-child > div .van-count-down {
  color: var(--victoria-text);
  font-size: 0.24rem;
}

.video-detail-page .movie-play-item > div:nth-child(2) {
  min-width: 0;
  height: auto;
  padding: 0.3rem;
  align-items: flex-start;
  justify-content: center;
}

.video-detail-page .movie-play-item > div:nth-child(2) p {
  width: 100%;
  height: auto;
  margin: 0 0 0.22rem;
  color: var(--victoria-text);
  font-size: 0.34rem;
  line-height: 1.45;
  word-break: break-word;
}

.video-detail-page .movie-play-item > div:nth-child(2) span {
  display: inline-flex;
  gap: 0.08rem;
  align-items: center;
  color: var(--victoria-text-muted);
  font-size: 0.28rem;
}

@media (min-width: 600px) {
  .video-detail-page .movie-video,
  .video-detail-page .movie-content {
    max-width: 8.8rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .video-detail-page * {
    scroll-behavior: auto !important;
  }
}
</style>
